import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

export const StatusFilter = ({ selectedValue, handleChange }) => {
  return (
    <FormControl variant="outlined" style={{ minWidth: "10rem" }}>
      <InputLabel id="status-label">Status</InputLabel>
      <Select
        labelId="status-label"
        value={selectedValue}
        onChange={handleChange}
        label="Status"
      >
        <MenuItem value={null}>
          <em>Todos</em>
        </MenuItem>
        <MenuItem value={2}>A confirmar</MenuItem>
        <MenuItem value={9}>Confirmado</MenuItem>
        <MenuItem value={4}>Recusado</MenuItem>
        <MenuItem value={8}>Cancelado</MenuItem>
        <MenuItem value={5}>Não trouxe</MenuItem>
      </Select>
    </FormControl>
  );
};
